function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
import { useNavigation } from "@limitless/portal/hooks/navigation/NavigationContext";
import Typography from "../../data-display/typography/Typography";
const Breadcrumbs = ({
  items = [],
  id = "Breadcrumbs-default-id",
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const {
    navigate
  } = useNavigation();
  return /*#__PURE__*/React.createElement(MuiBreadcrumbs, _extends({
    id: id
  }, rest, {
    sx: {},
    maxItems: 3,
    separator: "\u203A",
    "aria-label": "breadcrumb"
  }), items.map((item, index) => {
    if (index === items.length - 1) {
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        onClick: item.href ? () => navigate(item.href, true) : () => null,
        key: `bread_${index}`
      }, t(item.text));
    } else {
      return /*#__PURE__*/React.createElement(Link, {
        underline: "none",
        onClick: item.href ? () => navigate(item.href, true) : () => null,
        key: `bread_${index}`,
        sx: item.href && {
          cursor: "pointer"
        }
      }, t(item.text));
    }
  }));
};
Breadcrumbs.propTypes = {
  items: PropTypes.array,
  id: PropTypes.string
};
export default Breadcrumbs;